export default __webpack_public_path__ + "images/one_02c2e3.svg";